export default __webpack_public_path__ + "static/media/add-image-outline.b262f83d.png";